import { useTranslation } from 'react-i18next';

import { showModal } from 'actions/modal';

import Hotkey from 'components/Hotkey';

import IconSearch from 'icons/icon-search';

import './AppSearch.styles.css';

const AppSearch = () => {
    const { t } = useTranslation('common');

    const handleClick = () => {
        showModal('SEARCH_MODAL');
    }

    return (
        <div className="app-search-button" onClick={handleClick}>
            <div className="app-search-button-main">
                <IconSearch />

                { t('searchBarText') }
            </div>

            <Hotkey metaKey={true} keyName="K" />
        </div>
    )
}

export default AppSearch;
